var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"pd",attrs:{"href":"https://www.paypal.me/lashakitia/9.99","target":"_blank","title":"Help pay for hosting"}},[_vm._v("\n  Donate\n")])}
var staticRenderFns = []

export { render, staticRenderFns }